"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logicalOrder = void 0;

var port_index_1 = require("./port_index");

;
/* Public: logicalOrder compares two ports for sorting.
  *
  * Returns a positive number if a>b, negative if b>a and 0 if a=b
  */

function logicalOrder(a, b) {
  var aIndex = new port_index_1.PortIndex(a.index);
  var bIndex = new port_index_1.PortIndex(b.index);
  return aIndex.compare(bIndex);
}

exports.logicalOrder = logicalOrder;